@if (user) {
  <div class="wrapper">
    <div class="top kgr-scrollable">
      <div class="kgr-region kgr-region--big kgr-text kgr-text--centered">
        <div class="username kgr-headline kgr-headline--h3">{{ user.fullName }}</div>
      </div>

      <div class="kgr-region">
        <nav class="kgr-verticalMenu">
          @if ((users$ | async)?.length > 1) {
            <button (click)="toggleUserDropdown()" class="userDropdownToggle kgr-verticalMenu__item is-level-1 kgr-clickable">
              <span class="kgr-verticalMenu__itemIcon">
                <svg kgrIcon="users" [small]="true"></svg>
              </span>
              <span class="kgr-verticalMenu__itemLabel" i18n>Meine Familie</span>
              <svg kgrIcon="arrow-down" class="kgr-verticalMenu__itemAddendum kgr-icon"></svg>
            </button>
            <div class="kgr-collapsible" [class.is-open]="usersDropdownOpen">
              <div class="kgr-collapsible__content">
                @for (user of users$ | async; track user) {
                  <a [routerLink]="['/account/', user.id]" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-2">
                    <span class="kgr-verticalMenu__itemIcon">
                      <kgr-profile-image
                        [imageUrl]="
                          user.hasProfileImage
                            ? (user.profileImageApiUrl | apiImageUrl: 'profile_image_m' : user._cacheBuster | async)
                            : null
                        "
                        [gender]="user.gender"
                        [extraSmall]="true"
                      ></kgr-profile-image>
                    </span>
                    <span class="kgr-verticalMenu__itemLabel">{{ user.fullName }}</span>
                  </a>
                }
              </div>
            </div>
          } @else {
            <a
              [routerLink]="['/account/', user.id]"
              routerLinkActive="is-active"
              class="mainUserProfileMenuItem kgr-verticalMenu__item is-level-1"
            >
              <span class="kgr-verticalMenu__itemIcon">
                <kgr-profile-image
                  [imageUrl]="
                    user.hasProfileImage ? (user.profileImageApiUrl | apiImageUrl: 'profile_image_m' : user._cacheBuster | async) : null
                  "
                  [gender]="user.gender"
                  [extraSmall]="true"
                ></kgr-profile-image>
              </span>
              <span class="kgr-verticalMenu__itemLabel" i18n>Mein Profil</span>
            </a>
          }

          <a *kgrIfModuleEnabled="'dog'" routerLink="/dogs" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
            <span class="kgr-verticalMenu__itemIcon">
              <svg kgrIcon="pets" [small]="true"></svg>
            </span>
            <span class="kgr-verticalMenu__itemLabel" i18n>Hunde</span>
          </a>

          @if ((organization$ | async)?.membersCanViewInvoices) {
            <a routerLink="/accounting" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
              <span class="kgr-verticalMenu__itemIcon">
                <svg kgrIcon="calculate" [small]="true"></svg>
              </span>
              <span class="kgr-verticalMenu__itemLabel" i18n>Rechnungen</span>
              <kgr-badge-counter [key]="BADGE_KEY_INVOICE" class="kgr-verticalMenu__itemAddendum"></kgr-badge-counter>
            </a>
          }

          <a routerLink="/preferences" routerLinkActive="is-active" class="kgr-verticalMenu__item is-level-1">
            <span class="kgr-verticalMenu__itemIcon">
              <svg kgrIcon="settings" [small]="true"></svg>
            </span>
            <span class="kgr-verticalMenu__itemLabel" i18n>Einstellungen</span>
          </a>
        </nav>
      </div>
    </div>
    <div class="bottom kgr-region kgr-region--big">
      <hr class="kgr-separator kgr-separator--light" />

      <label>
        <div class="kgr-verticalMenu__itemHeader" i18n>Sprachen</div>
        <kgr-menu-language-switch
          [locales]="['de', 'en', 'es', 'tr', 'uk']"
          (localeChanged)="setLocaleId($event)"
        ></kgr-menu-language-switch>
      </label>

      <hr class="kgr-separator kgr-separator--light" />

      @if (hasMultipleAccounts$ | async) {
        <a routerLink="/user/switch" class="kgr-button kgr-button--accent kgr-button--block kgr-button--outline kgr-row">
          <svg class="kgr-button__icon kgr-button__icon--left" kgrIcon="users"></svg>
          <ng-container i18n>Benutzer wechseln</ng-container>
        </a>
      }

      <a routerLink="/user/logout" class="kgr-button kgr-button--accent kgr-button--block kgr-button--outline">
        <svg class="kgr-button__icon kgr-button__icon--left" kgrIcon="door-exit"></svg>
        <ng-container i18n>Logout</ng-container>
      </a>
    </div>
  </div>
} @else {
  <div class="kgr-region">
    <nav class="kgr-verticalMenu">
      <label>
        <div class="kgr-verticalMenu__itemHeader" i18n>Sprachen</div>
        <kgr-menu-language-switch
          [locales]="['de', 'en', 'es', 'tr', 'uk']"
          (localeChanged)="setLocaleId($event)"
        ></kgr-menu-language-switch>
      </label>
    </nav>
  </div>
}
